import { Button, Colors, QuestionCircleLine, Text } from '@revenuemarket/cds';

const GuideButton = ({ link }: { link: string }) => {
  return (
    <Button
      buttonType="weak"
      border
      icon={<QuestionCircleLine width={18} height={18} fill={Colors.gray700} />}
      onClick={() => {
        window.open(link, '_blank', 'noopener,noreferrer');
      }}
    >
      <Text textStyle="14_500" color={Colors.gray700}>
        가이드
      </Text>
    </Button>
  );
};

export default GuideButton;
